import React, { useState } from 'react'
import { Icon } from 'components/Icons'
import styles from './Tabs.module.scss'

/**
 * Универсальный компонент табов.
 *   <Tabs
 *     tabs={[
 *       { key: 'overview', label: 'Обзор', icon: 'home' },
 *       { key: 'history', label: 'История', icon: 'history', badge: 12 },
 *     ]}
 *     active={tab}
 *     onChange={setTab}
 *     variant="line" // или "pills" / "boxed"
 *   />
 */
const Tabs = ({
  tabs = [],
  active,
  onChange,
  variant = 'line',
  className = '',
  fullWidth = false,
  size = 'md',
}) => {
  const [internal, setInternal] = useState(tabs[0]?.key)
  const current = active ?? internal
  const set = (k) => {
    if (active === undefined) setInternal(k)
    if (onChange) onChange(k)
  }

  return (
    <div
      role="tablist"
      className={[
        styles.tabs,
        styles[`v_${variant}`],
        fullWidth ? styles.fullWidth : '',
        styles[`s_${size}`],
        className,
      ].filter(Boolean).join(' ')}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={current === tab.key}
          aria-controls={`tabpanel-${tab.key}`}
          tabIndex={current === tab.key ? 0 : -1}
          className={`${styles.tab} ${current === tab.key ? styles.active : ''}`}
          onClick={() => set(tab.key)}
          disabled={tab.disabled}
        >
          {tab.icon && <Icon name={tab.icon} size={16} color="currentColor" />}
          <span className={styles.label}>{tab.label}</span>
          {tab.badge !== undefined && tab.badge !== null && (
            <span className={styles.badge}>{tab.badge}</span>
          )}
        </button>
      ))}
    </div>
  )
}

const TabPanel = ({ tabKey, active, children }) => (
  <div
    role="tabpanel"
    id={`tabpanel-${tabKey}`}
    hidden={active !== tabKey}
    className={styles.panel}
  >
    {active === tabKey ? children : null}
  </div>
)

Tabs.Panel = TabPanel

export default Tabs
